import { render, staticRenderFns } from "./TrendyolChannelDetail.vue?vue&type=template&id=ba6a3c2a&scoped=true"
import script from "./TrendyolChannelDetail.vue?vue&type=script&lang=js"
export * from "./TrendyolChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./TrendyolChannelDetail.vue?vue&type=style&index=0&id=ba6a3c2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6a3c2a",
  null
  
)

export default component.exports